import styled from 'styled-components'

export const Image = styled.div`
    height: 90vh;
    width: auto;
    /* border: 1px solid green; */

     img {
        height: 100%;
        width: auto;
        object-fit: cover;
    }
`
export const Message = styled.div`
    font-size: 0.7rem;
    margin-bottom: 10px;
    text-align: center;
`
